module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_null@3x.29bc5f4d.png";